<div *ngIf="!IsLoadedInMenu()">
  <app-page-header></app-page-header>
  <div class="activeMenu">
    <div class="mat-form-field-wrapper">
      <div class="mat-form-field-label">
        <h3>{{ 'Menu.Cambio Password' | translate }}</h3>
      </div>
    </div>
  </div>
</div>

<section class="vh-90" style="background-color: #b0cafa;">
  <div class="container py-5 h-100">
    <div class="row d-flex justify-content-center align-items-center h-100">
      <div class="col-12 col-md-8 col-lg-6 col-xl-5">
        <div class="card shadow-2-strong" style="border-radius: 1rem;">
          <div class="card-body p-5 text-center">
            <div class="form-outline mb-3">
              <input type="password" id="typePasswordX-20" class="form-control form-control-lg" [(ngModel)]="oldPassword"/>
              <label class="form-label" for="typePasswordX-20">
                {{ 'User.CurrentPassword' | translate }}
              </label>

              <input type="password" id="typePasswordX-3" class="form-control form-control-lg" [(ngModel)]="newPassword"/>
              <label class="form-label" for="typePasswordX-3">
                {{ 'User.NewPassword' | translate }}
              </label>

              <input type="password" id="typePasswordX-4" class="form-control form-control-lg" [(ngModel)]="newPasswordRetyped"/>
              <label class="form-label" for="typePasswordX-4">
                {{ 'User.RepeatNewPassword' | translate }}
              </label>

              <div class="form-outline mb-3" *ngIf="oldPasswordIsValid === false">
                <label class="form-label" style="color: rgb(236, 77, 77);">
                  {{ 'User.Message.WrongPassword' | translate }}
                </label>
              </div>
              <div class="form-outline mb-3" *ngIf="newPasswordMatch === false">
                <label class="form-label" style="color: rgb(236, 77, 77);">
                  {{ 'User.Message.NewPasswordMisatch' | translate }}
                </label>
              </div>
              <div class="form-outline mb-3" *ngIf="newPasswordIsValid === false">
                <label class="form-label" style="color: rgb(236, 77, 77);">
                  {{ 'User.Message.NewPasswordIsInvalid' | translate }}
                </label>
              </div>
            </div>

            <div>
              <button class="btn btn-primary btn-lg btn-primary btn-block" (click)="UserChangePassword()" [disabled]="oldPassword==='' || newPassword==='' || newPasswordRetyped==='' ">
                {{ 'Main.Button.Confirm' | translate }}
              </button>
              <button class="btn btn-primary btn-lg btn-block ms-3" (click)="UserChangePasswordCancelled()">
                {{ 'Main.Button.Cancel' | translate }}
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</section>
